import { brandColors } from 'colors';
import Button from 'domains/core/components/Button';
import theme from 'theme';

type Props = {
    dataTestId: string;
    handleClick: () => void;
};

const addSubFilterButtonSx = {
    background: 'white',
    boxShadow: 'none',
    width: '160px',
    color: theme.palette.secondary.main,
    border: `2px solid ${theme.palette.secondary.main}`,
    '&:hover': {
        background: brandColors.stone,
        boxShadow: 'none',
    },
};

const AddSubFilterButton = ({ dataTestId, handleClick }: Props) => (
    <Button data-testid={dataTestId} variant="contained" size="small" sx={addSubFilterButtonSx} onClick={handleClick}>
        + Add sub filter
    </Button>
);

export default AddSubFilterButton;
